import { Component, EventEmitter, Output } from '@angular/core';
import { LocalStorageService } from '../../local-storage/local-storage.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

function atLeastOneCheckedValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const values = group.value as Record<string, boolean>;
    const alMenosUno = Object.values(values).some((v) => v === true);
    return alMenosUno ? null : { atLeastOne: true };
  };
}

@Component({
  selector: 'app-autorizacion-radicacion',
  templateUrl: './autorizacion-radicacion.component.html',
})
export class AutorizacionRadicacionComponent {
  @Output() estadoValido = new EventEmitter<boolean>();

  canales = [
    { control: 'todos', label: 'Todos los canales' },
    { control: 'correo', label: 'Correo electrónico' },
    {
      control: 'redes',
      label: 'Redes sociales (WhatsApp y otros equivalentes)',
    },
    { control: 'mensaje', label: 'Mensaje de texto y multimedia' },
    { control: 'telefono', label: 'Teléfono fijo y celular' },
  ];

  form: FormGroup = this.fb.group({
    canales: this.fb.group(
      {
        todos: [false],
        correo: [false],
        redes: [false],
        mensaje: [false],
        telefono: [false],
      },
      { validators: atLeastOneCheckedValidator() },
    ),
    contactoMultiple: [null, Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit() {
    this.restoreForm();
    this.listenFormChanges();

    this.form.statusChanges.subscribe(() => {
      this.estadoValido.emit(this.form.valid);
    });

    this.estadoValido.emit(this.form.valid);
  }

  get canalesInvalid(): boolean {
    const values = this.form.get('canales')?.value;
    return !Object.values(values).some((v) => v === true);
  }

  onCanalChange(control: string) {
    const canalesGroup = this.form.get('canales') as FormGroup;

    if (control === 'todos') {
      const checked = canalesGroup.get('todos')?.value;
      Object.keys(canalesGroup.controls).forEach((key) => {
        canalesGroup.get(key)?.setValue(checked, { emitEvent: false });
      });
    } else {
      const allSelected = Object.keys(canalesGroup.controls)
        .filter((k) => k !== 'todos')
        .every((k) => canalesGroup.get(k)?.value);

      canalesGroup.get('todos')?.setValue(allSelected, { emitEvent: false });
    }

    canalesGroup.updateValueAndValidity();
    this.saveForm();
  }

  private saveForm() {
    this.localStorageService.save(
      'autorizacion_radicacion_form',
      this.form.value,
    );
  }

  private restoreForm() {
    const saved = this.localStorageService.load('autorizacion_radicacion_form');

    if (saved) {
      this.form.patchValue(saved, { emitEvent: false });
    }
  }

  private listenFormChanges() {
    this.form.valueChanges.subscribe((value) => {
      this.localStorageService.save('autorizacion_radicacion_form', value);
    });
  }
}
